<template>
    <div class="flex w-full justify-start items-center">

        <div v-if="!_currentFolder || way == 'search'" class="font-bold">{{ title }}</div>
        <inertia-link v-else :href="route('library.' + rootFolder)" class="block font-bold hover:underline">{{ title
            }}</inertia-link>

        <div v-if="way != 'search'" class="flex items-center justify-start">
            <span v-if="foldersOrdered.length > 0 || canEdit" class="font-bold ml-2">/</span>
            <div class="flex items-center gap-x-2">
                <div class="flex items-center gap-x-1">
                    <div class="bg-transparent w-full bg-red-200 flex items-center justify-start">

                        <Listbox v-if="foldersOrdered.length > 0" as="div" v-model="current_folder_id"
                            class="max-w-60 w-full ml-1" @update:modelValue="changeFolder">
                            <div class="relative">
                                <ListboxButton
                                    class="flex w-full items-center justify-start rounded-md bg-white py-1 pl-2 pr-2 text-left text-gray-900 outline outline-0 -outline-offset-1 outline-gray-300 sm:text-sm/6  hover:bg-gray-100 gap-x-1">

                                    <LockClosedIcon v-if="_currentFolder && _currentFolder.is_secure"
                                        class="size-3 text-gray-500 flex-shrink-0" aria-hidden="true" />

                                    <span v-if="_currentFolder" class="inline-block truncate pr-1">{{
                                        _currentFolder.name
                                        }}</span>
                                    <span v-else class="inline-block truncate pr-2 text-gray-400">Go to Folder</span>

                                    <!-- <span class="truncate text-gray-500">{{ currentFolder.slug }}</span> -->

                                    <ChevronUpDownIcon
                                        :class="[_currentFolder ? 'text-gray-500' : 'text-gray-400', 'size-5 self-center  sm:size-4 flex-shrink-0']"
                                        aria-hidden="true" />

                                </ListboxButton>

                                <transition leave-active-class="transition ease-in duration-100"
                                    leave-from-class="opacity-100" leave-to-class="opacity-0">
                                    <ListboxOptions
                                        class="w-60 absolute mt-1 max-h-60 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-birdie-blue sm:text-sm z-50">

                                        <ListboxOption v-if="currentFolder != null" as="template" key="folder_root"
                                            :value="rootFolder" v-slot="{ active, selected }">
                                            <li
                                                :class="[active ? 'bg-birdie-blue text-white outline-none' : 'text-gray-900',
                                                    'relative cursor-default select-none py-2 pl-3 pr-2 flex items-center justify-between group w-60']">

                                                <FolderIconSolid class="size-4 mr-2" />

                                                <span :class="['inline-block truncate flex-1']">{{
                                                    title }}</span>
                                            </li>
                                        </ListboxOption>

                                        <ListboxOption as="template" v-for="folder in foldersOrdered" :key="folder.id"
                                            :value="folder.id" v-slot="{ active, selected }">
                                            <li
                                                :class="[active ? 'bg-birdie-blue text-white outline-none' : 'text-gray-900',
                                                folder.is_secure && !folder.can_access ? 'pointer-events-none opacity-50' : '',
                                                currentFolder != null ? 'pl-8' : 'pl-3',
                                                    'relative cursor-default select-none py-2 pr-2 flex items-center justify-between gap-x-2 group w-60']">
                                                <span class="inline-block relative h-4 w-4 shrink-0">
                                                    <FolderIconOutline class="size-4" />
                                                    <div v-if="folder.is_secure"
                                                        class="absolute bottom-0 -right-0.5 size-2 rounded-full bg-white group-hover:bg-birdie-blue flex items-center justify-center text-gray-900 group-hover:text-white">
                                                        <LockClosedIcon class="size-5/6 " />
                                                    </div>
                                                </span>

                                                <span
                                                    :class="[selected ? 'font-semibold' : 'font-normal', 'inline-block truncate flex-1']">{{
                                                        folder.name }}</span>

                                                <span v-if="selected"
                                                    :class="[active ? 'text-white' : 'text-gray-800', 'flex items-center justify-center shrink-0']">
                                                    <CheckIcon class="size-4" aria-hidden="true" />
                                                </span>
                                            </li>
                                        </ListboxOption>
                                    </ListboxOptions>
                                </transition>
                            </div>
                        </Listbox>


                        <Menu v-if="canEdit" as="div" class="ml-2 relative z-50" v-slot="{ close }">
                            <div class="flex items-center justify-center size-6">
                                <MenuButton
                                    class="flex items-center justify-center rounded bg-white text-gray-400 hover:bg-gray-100 size-6">
                                    <span class="sr-only">Open options</span>
                                    <EllipsisHorizontalIcon class="size-4" aria-hidden="true" />
                                </MenuButton>
                            </div>

                            <transition enter-active-class="transition ease-out duration-100"
                                enter-from-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-from-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95">
                                <MenuItems
                                    class="absolute left-0 z-10 mt-2 w-48   origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
                                    <div class="py-1">
                                        <MenuItem v-if="_currentFolder" v-slot="{ active }">
                                        <a href="#" @click.prevent.stop="editFolder(_currentFolder); close()"
                                            :class="[active ? 'bg-gray-100 text-gray-900 outline-none' : 'text-gray-700', 'px-4 py-2 text-sm flex items-center justify-start']">
                                            <PencilSquareIcon class="size-4 mr-2" />
                                            Edit
                                            Folder
                                        </a>
                                        </MenuItem>
                                        <MenuItem v-slot="{ active }">
                                        <a href="#" @click.prevent.stop="createNewFolder(); close()"
                                            :class="[active ? 'bg-gray-100 text-gray-900 outline-none' : 'text-gray-700', 'px-4 py-2 text-sm flex items-center justify-start']">
                                            <PlusIcon class="size-4 mr-2" />
                                            Create
                                            new Folder
                                        </a>
                                        </MenuItem>
                                    </div>
                                </MenuItems>
                            </transition>
                        </Menu>






                    </div>
                </div>
            </div>

        </div>

        <TransitionRoot as="div" :show="open">
            <Dialog as="div" class="relative z-[71]" @close="open = false">
                <TransitionChild as="div" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                    leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
                </TransitionChild>

                <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <TransitionChild as="div" enter="ease-out duration-300"
                            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                            leave-from="opacity-100 translate-y-0 sm:scale-100"
                            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                            <DialogPanel v-if="folderToEdit"
                                class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8  sm:p-6"
                                :key="'folderToEditKey_' + folderToEditKey" style="width:32rem">
                                <div>
                                    <div class="mt-1 text-center">
                                        <DialogTitle as="h3"
                                            class="text-base font-semibold text-gray-900 flex justify-center items-center gap-x-2">
                                            <span class="inline-block relative size-5">
                                                <FolderIconOutline class="size-5" />
                                                <div v-if="folderToEdit.is_secure"
                                                    class="absolute -bottom-0.5 -right-1 size-3 rounded-full bg-white flex items-center justify-center">
                                                    <LockClosedIcon class="size-5/6" />
                                                </div>
                                            </span>
                                            <span v-if="folderToEdit.id == 'new'">Create New
                                                Folder</span>
                                            <span v-else>Edit Folder</span>
                                        </DialogTitle>

                                        <div class="mt-8 flex flex-col gap-y-5">

                                            <div class="flex items-center pt-2">
                                                <label for="name"
                                                    class="block text-sm/6 font-medium text-gray-900 min-w-20 text-right pr-4">Name</label>
                                                <div class="flex-grow">
                                                    <div
                                                        class="flex items-center rounded-md bg-white outline outline-0 -outline-offset-0 outline-gray-300 sm:max-w-md">
                                                        <input type="text" ref="name" v-model="folderToEdit.name"
                                                            @input="changedFolderName" class="text-left w-full inline py-2 mt-0 px-3 border-0
                                                        border-gray-200 focus:ring-0 focus:border-blue-500 font-medium
                                                        bg-gray-100 focus:bg-blue-50 text-birdie-blue
                                                        focus:text-blue-600 rounded-lg text-sm placeholder:font-normal"
                                                            placeholder="Untitled" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="rootFolder == 'incoming'" class="flex items-start">
                                                <label for="is_secure"
                                                    class="block text-sm/6 font-medium text-gray-900 min-w-20 text-right pr-4">Restricted</label>
                                                <div class="flex-grow">
                                                    <div class="text-xs text-gray-500 text-left pt-1">
                                                        Access-restricted folders can be viewed by <span
                                                            v-if="!folderToEdit.is_secure">Admins and
                                                            selected
                                                            Members.</span><span v-else>all Admins.<br />Select the
                                                            Members who should have access.</span>
                                                    </div>
                                                </div>
                                                <toggle v-if="plan_secure_folders" class="flex-shrink-0"
                                                    :checked="folderToEdit.is_secure" @click.prevent.stop
                                                    @update="folderToEdit.is_secure = !folderToEdit.is_secure">
                                                </toggle>
                                                <UpgradePlan v-else class="flex-shrink-0" />
                                            </div>
                                            <div class="flex items-start -mt-5">
                                                <label
                                                    class="block text-sm/6 font-medium text-gray-900 min-w-20 text-right pr-4"></label>
                                                <div class="flex-grow">
                                                    <transition name="expand" @enter="enter" @leave="leave"
                                                        @transitionstart="shrinkComplete = false"
                                                        @transitionend="shrinkComplete = !folderToEdit.is_secure">
                                                        <div v-if="folderToEdit.is_secure && plan_secure_folders"
                                                            class="w-full h-48 max-h-48 bg-white overflow-hidden mt-2">
                                                            <FolderRestrictedTeamMembers :folder="folderToEdit"
                                                                :teamMembers="teamMembers"
                                                                @updateMemberSelectedIds="updateMemberSelectedIds" />
                                                        </div>
                                                    </Transition>
                                                </div>
                                            </div>

                                            <div v-if="folderToEdit.id != 'new'" class="flex items-center">
                                                <label for="is_secure"
                                                    class="block text-sm/6 font-medium text-gray-900 min-w-20 text-right pr-4">Delete</label>
                                                <div class="flex-grow flex items-center justify-between gap-x-2">
                                                    <div v-if="folderToEdit.videos_count > 0"
                                                        class="text-xs text-gray-500 text-left">You can only delete
                                                        empty folders. Remove all videos first.</div>
                                                    <div v-else @click="deleteFolder()"
                                                        class="text-sm text-red-600 text-left font-bold hover:underline cursor-pointer">
                                                        delete
                                                        permanently
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="mt-5 sm:mt-10 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                    <button type="button"
                                        class="inline-flex w-full justify-center rounded-md bg-birdie-blue px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-birdie-blue-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-birdie-blue sm:col-start-2"
                                        @click="saveEditedFolder"
                                        :class="{ 'opacity-50': folderToEdit.name.length == 0 }"
                                        :disabled="folderToEdit.name.length == 0 || saving">Save</button>
                                    <button type="button"
                                        class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                                        @click="closeEditedFolder" :disabled="saving"
                                        ref="cancelButtonRef">Cancel</button>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </TransitionRoot>

    </div>
</template>

<script>
import { LockClosedIcon, PencilSquareIcon, PlusIcon, ChevronUpDownIcon, EllipsisHorizontalIcon, ArrowLeftIcon } from "@heroicons/vue/16/solid";

import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

import Toggle from '@/Components/UI/Toggle'

import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'
import FolderRestrictedTeamMembers from '@/Components/UI/FolderRestrictedTeamMembers'
import UpgradePlan from '@/Components/UI/UpgradePlan'
import { CheckIcon, FolderIcon as FolderIconOutline } from "@heroicons/vue/24/outline"
import { FolderIcon as FolderIconSolid } from "@heroicons/vue/24/solid"


export default {
    name: 'Folders',
    props: {
        way: {
            type: String,
            default: 'incoming'
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        currentFolder: {
            type: Object,
            default: {}
        },
        folders: {
            type: Array,
            default: []
        },
        plan_secure_folders: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PencilSquareIcon, PlusIcon,
        Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot,
        CheckIcon, LockClosedIcon, Toggle, EllipsisHorizontalIcon,

        ArrowLeftIcon, FolderIconOutline, FolderIconSolid, UpgradePlan,

        ChevronUpDownIcon,
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,

        Menu, MenuButton, MenuItem, MenuItems,

        FolderRestrictedTeamMembers
    },
    data() {
        return {
            max_characters: 50,
            current_folder_id: 0,
            folderList: [],
            _currentFolder: this.currentFolder,
            newFolderName: '',
            open: false,
            folderToEdit: null,
            keepEditedFolder: null,
            folderToEditKey: 0,
            saving: false,
            shrinkComplete: true,
            teamMembers: null,
            //folderIcon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 -960 960 960" stroke="none" fill="currentColor"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160H160Zm0-80h640v-400H447l-80-80H160v480Zm0 0v-480 480Z"/></svg>'
        }
    },
    created() {
        this.refreshFolders()
        if (this.currentFolder) {
            this.current_folder_id = this.currentFolder.id
        }
    },
    methods: {
        enter(element) {

            const width = getComputedStyle(element).width;
            element.style.width = width;
            element.style.position = 'absolute';
            element.style.visibility = 'hidden';
            element.style.height = 'auto';

            const height = getComputedStyle(element).height;
            element.style.width = null;
            element.style.position = null;
            element.style.visibility = null;
            element.style.height = 0;

            // Force repaint
            getComputedStyle(element).height;

            // Add transition
            element.style.height = height;
        },

        leave(element) {

            const height = getComputedStyle(element).height;
            element.style.height = height;

            // Force repaint
            getComputedStyle(element).height;

            // Add transition
            element.style.height = 0;
        },
        changeFolder(event) {
            if (this._currentFolder == null || this.current_folder_id != this._currentFolder.id) {
                if (this.current_folder_id == this.rootFolder) {
                    this.goToRoot()
                    return
                }
                const newFolder = this.folders.find(folder => folder.id == this.current_folder_id)
                if (newFolder.is_secure && !newFolder.can_access) {
                    return
                }
                this.$inertia.visit(route('library.' + this.rootFolder, { folder_slug: newFolder.slug }))
            }
        },
        goToRoot() {
            this.$inertia.visit(route('library.' + this.rootFolder))
        },
        refreshFolders() {
            this.folderList = this.folders
        },
        createNewFolder() {
            const newFolder = {
                id: 'new',
                name: '',
                is_secure: false
            }
            this.editFolder(newFolder)
        },
        updateMemberSelectedIds(memberSelectedIds) {
            // console.log("updateMemberSelectedIds", memberSelectedIds)
            this.folderToEdit.memberSelectedIds = memberSelectedIds
        },
        editFolder(folder) {
            if (folder.is_secure && !folder.can_access) {
                return
            }
            this.folderToEditKey++
            this.folderToEdit = JSON.parse(JSON.stringify(folder))
            if (this.teamMembers == null) {
                this.getTeamMembers()
            }
            this.folderToEdit.memberSelectedIds = this.folderToEdit.users?.map(user => user.id) || []

            // if (this.folderToEdit.is_secure) {
            //     this.shrinkComplete = false
            // }
            this.open = true
        },
        getTeamMembers() {
            let url = this.$page.props.api_url + '/v1/team/members'
            axios.get(url)
                .then(response => {
                    this.teamMembers = response.data
                })
                .catch(e => {
                    console.error(e);
                })
        },
        changedFolderName() {
            // limit characters to everything a-z , 0-9, accents but no punctuation nor special chars except - and _
            this.folderToEdit.name = this.folderToEdit.name.replace(/[^a-zA-Z0-9À-ÿ\s\-_,;\/\(\)\[\]\{\}]/g, '').slice(0, this.max_characters)
        },
        closeEditedFolder() {
            this.open = false
            this.folderToEdit = null
        },

        deleteFolder() {
            this.folderToEdit.is_deletion = true
            this.saveEditedFolder()
        },

        saveEditedFolder() {
            if (this.folderToEdit.name.length == 0) {
                return
            }

            this.saving = true
            let is_creation = true
            let is_deletion = this.folderToEdit.is_deletion
            let url = this.$page.props.api_url + '/v1/folder'

            if (this.folderToEdit.id !== 'new') {
                is_creation = false
                url = this.$page.props.api_url + '/v1/folder/' + this.folderToEdit.id
                if (is_deletion) {
                    url += '/delete'
                }
            }

            if (!this.plan_secure_folders && this.folderToEdit.is_secure) {
                const errorMessage = "Upgrade your Plan to enable Restricted folders"
                let options = {
                    type: "danger",
                    timeout: 6000,
                    position: "top-right",
                    hideProgressBar: false,
                }
                this.$moshaToast(errorMessage, options)
            }

            axios.post(url, {
                name: this.folderToEdit.name.trim(),
                root: this.rootFolder,
                is_secure: this.folderToEdit.is_secure,
                memberSelectedIds: this.folderToEdit.is_secure ? this.folderToEdit.memberSelectedIds : []
            })
                .then(response => {
                    console.log("saveEditedFolder", response.data)
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    let message = 'Folder updated'
                    if (is_creation) {
                        message = 'Folder created'
                    } else if (is_deletion) {
                        message = 'Folder deleted'
                    }
                    this.$moshaToast(message, options)
                    const newFolder = response.data
                    newFolder.can_access = true
                    if (is_creation) {
                        this.folderList.push(response.data)
                    } else if (!is_deletion) {
                        // replace the old folder with the new one
                        const index = this.folderList.findIndex(folder => folder.id === this.folderToEdit.id)
                        if (index !== -1) {
                            this.folderList[index] = newFolder
                        }
                        this._currentFolder = newFolder
                    }
                    this.saving = false
                    this.open = false
                    this.folderToEdit = null
                    if (is_deletion) {
                        this.goToRoot()
                    } else {
                        this.$emit('refreshFolderList', this.folderList)
                    }
                })
                .catch(e => {
                    console.error(e);
                    const errorMessage = typeof e.response.data === 'string'
                        ? e.response.data
                        : e.response.data.message || 'An unknown error occurred';
                    let options = {
                        type: "danger",
                        timeout: 10000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("An error occurred:" + errorMessage, options)
                    this.saving = false
                    this.open = false
                    this.folderToEdit = null
                });


        }
    },
    computed: {
        foldersOrdered() {
            return this.folderList.sort((a, b) => a.name.localeCompare(b.name))
        },
        title() {
            if (this.way == 'my') {
                return 'Personal'
            } else if (this.way == 'sent') {
                return 'Team'
            } else if (this.way == 'search') {
                return 'Search results'
            } else if (this.way == 'received') {
                return 'Incoming'
            }
            return ''
        },
        rootFolder() {
            if (this.way == 'my') {
                return 'personal'
            } else if (this.way == 'sent') {
                return 'team'
            } else if (this.way == 'received') {
                return 'incoming'
            }
        }
    },
    // watch: {
    //     'folderToEdit.is_secure'(newVal) {
    //         if (!newVal) {
    //             this.shrinkComplete = true;
    //         }
    //     }
    // }
}
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
    transition: height 0.3s ease-in-out;
    overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
    height: 0;
}
</style>
